export const SettingsTab = async (container) => {
    container.innerHTML = `
        <div class="animate-fade-in p-1">
            <h2 class="text-2xl font-black text-gray-900 tracking-tight flex items-center gap-2 mb-6">
                <span class="material-symbols-outlined text-gray-400 text-3xl">settings</span> SYSTEM SETTINGS
            </h2>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Business Info Card -->
                <div class="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
                    <div class="flex items-center justify-between mb-4">
                        <h3 class="font-bold text-lg text-gray-900">사업자 정보 설정</h3>
                        <span class="material-symbols-outlined text-indigo-500 bg-indigo-50 p-2 rounded-lg">storefront</span>
                    </div>

                    <form id="form-business-info" class="space-y-3">
                         <div class="space-y-1">
                            <label class="text-xs font-bold text-gray-500">상호명 (Company Name)</label>
                            <input type="text" name="companyName" class="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="예: 썰화 월드">
                        </div>
                        <div class="grid grid-cols-2 gap-3">
                            <div class="space-y-1">
                                <label class="text-xs font-bold text-gray-500">대표자 (CEO)</label>
                                <input type="text" name="ceo" class="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="예: 홍길동">
                            </div>
                            <div class="space-y-1">
                                <label class="text-xs font-bold text-gray-500">사업자번호 (Biz No)</label>
                                <input type="text" name="licenseNum" class="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="000-00-00000">
                            </div>
                        </div>
                        <div class="space-y-1">
                            <label class="text-xs font-bold text-gray-500">통신판매업신고 (Mail Order)</label>
                            <input type="text" name="mailOrderLicense" class="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="제 2024-서울강남-0000호">
                        </div>
                        <div class="space-y-1">
                            <label class="text-xs font-bold text-gray-500">주소 (Address)</label>
                            <input type="text" name="addr" class="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="서울시 ...">
                        </div>
                        <div class="grid grid-cols-2 gap-3">
                             <div class="space-y-1">
                                <label class="text-xs font-bold text-gray-500">고객센터 (Tel)</label>
                                <input type="text" name="tel" class="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="02-000-0000">
                            </div>
                            <div class="space-y-1">
                                <label class="text-xs font-bold text-gray-500">이메일 (Email)</label>
                                <input type="email" name="email" class="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="help@ssulwha.com">
                            </div>
                        </div>

                        <div class="flex items-center gap-2 py-2 bg-indigo-50/50 px-3 rounded-lg border border-indigo-100">
                            <input type="checkbox" id="chk-auto-translate" class="accent-indigo-600 w-4 h-4 rounded border-gray-300" checked>
                            <label for="chk-auto-translate" class="text-xs font-bold text-indigo-800 cursor-pointer select-none flex items-center gap-1">
                                <span class="material-symbols-outlined text-[16px]">translate</span>
                                Save with Auto-Translation (Global 9 Languages)
                            </label>
                        </div>

                        <button type="submit" id="btn-save-biz" class="w-full py-2.5 mt-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-bold text-xs shadow-md transition-all flex items-center justify-center gap-2">
                            <span class="material-symbols-outlined text-base">save</span> 저장하기
                        </button>
                    </form>
                </div>

                <!-- ... (Data Migration Card remains unchanged) ... -->
                
                <!-- (Skipping migration card code for brevity in replace, but wait, replace should be precise) -->
                <!-- Since the ReplacementContent must be contiguous, I will target the form area specifically -->
                <!-- Wait, I need to include the imports and logic below too. -->
                <!-- The selection is too large if I include everything. I will do it in chunk 1 (UI) and chunk 2 (Logic). -->
                <!-- Converting to Multireplace/Parallel or just 2 steps. The tool says "Use multi_replace". -->
                <!-- But I only have replace_file_content selected. I'll do UI first, then Logic. -->
                <!-- Actually, I can replace the logic block separately. -->
                <!-- Step 1: UI Checkbox Addition -->
    
                    </form>
                </div>


                <!-- Data Migration Card -->
                <div class="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
                    <div class="flex items-start justify-between mb-4">
                        <div>
                            <h3 class="font-bold text-lg text-gray-900">Point System Migration (v2)</h3>
                            <p class="text-sm text-gray-500 mt-1">
                                Migrates all legacy 'points' to 'activityPoints', initializes 'starPoints' to 0, 
                                and generates 'referralCode' for all users.
                            </p>
                        </div>
                        <span class="material-symbols-outlined text-orange-500 bg-orange-50 p-2 rounded-lg">database</span>
                    </div>

                    <div class="bg-gray-50 rounded-lg p-4 mb-4 border border-gray-100">
                        <ul class="text-xs text-gray-600 space-y-1 list-disc list-inside">
                            <li>Target: All Users in Firestore</li>
                            <li>Action: Update fields (activityPoints, referralCode)</li>
                            <li>Safe to run multiple times (Idempotent checks included)</li>
                        </ul>
                    </div>

                    <button id="btn-run-migration" class="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-bold text-sm shadow-md transition-all flex items-center justify-center gap-2">
                        <span class="material-symbols-outlined">play_arrow</span>
                        Run Migration Script
                    </button>
                    <div id="migration-log" class="mt-4 p-3 bg-black text-green-400 font-mono text-xs rounded-lg hidden h-32 overflow-y-auto"></div>
                </div>
            </div>
        </div>
    `;

    // --- Migration Logic --- (Kept as is)
    const btn = container.querySelector('#btn-run-migration');
    const log = container.querySelector('#migration-log');

    btn.onclick = async () => {
        const confirmed = await window.Modal.confirm(
            "Start Migration?",
            "This will migrate legacy points to Activity Points and generate referral codes for all users.<br><br><b>Target: All Users</b>"
        );
        if (!confirmed) return;

        btn.disabled = true;
        btn.classList.add('opacity-50');
        log.classList.remove('hidden');
        log.innerHTML = "> Starting migration module...\n";

        try {
            // Dynamic Import
            const { migratePoints } = await import("../../../services/migration.service.js");

            // Hook console.log to display in UI
            const originalLog = console.log;
            console.log = (msg, ...args) => {
                originalLog(msg, ...args);
                log.innerHTML += `> ${msg} ${args.join(' ')}\n`;
                log.scrollTop = log.scrollHeight;
            };

            await migratePoints();

            console.log = originalLog; // Restore
            log.innerHTML += "> [SUCCESS] Migration Finished.";
            await window.Modal.alert("Migration Completed Successfully!");

        } catch (e) {
            log.innerHTML += `> [ERROR] ${e.message}`;
            console.error(e);
            await window.Modal.alert("Migration Failed");
        } finally {
            btn.disabled = false;
            btn.classList.remove('opacity-50');
        }
    };

    // --- Business Settings Logic ---
    const form = container.querySelector('#form-business-info');
    const { getFirestore, doc, getDoc, setDoc } = await import("firebase/firestore");
    const { app } = await import("../../../firebase-config.js");
    const db = getFirestore(app);

    // 1. Load Data
    const loadSettings = async () => {
        try {
            const snap = await getDoc(doc(db, "settings", "businessInfo"));
            if (snap.exists()) {
                const data = snap.data();
                Object.keys(data).forEach(key => {
                    if (form[key]) form[key].value = data[key];
                });
            }
        } catch (e) {
            console.error("Failed to load settings:", e);
        }
    };
    loadSettings();

    // 2. Save Data
    // 2. Save Data
    form.onsubmit = async (e) => {
        e.preventDefault();
        const btnSave = form.querySelector('#btn-save-biz');
        const chkAutoTranslate = container.querySelector('#chk-auto-translate');

        btnSave.disabled = true;
        const originalBtnText = btnSave.innerHTML;
        btnSave.innerText = "저장 중...";

        try {
            const formData = new FormData(form);
            const data = {};
            formData.forEach((value, key) => data[key] = value);

            // [NEW] Intelligent Auto-Translation Logic
            if (chkAutoTranslate && chkAutoTranslate.checked) {
                btnSave.innerText = "번역 생성 중...";
                const { templateTranslationService: TranslationService } = await import("../../../services/TranslationService.js");
                const targetLocales = ['en', 'ja', 'zh', 'vi', 'th', 'fr', 'de', 'ru', 'es'];

                // Prepare fields to translate
                const fieldsToTranslate = {
                    companyName: data.companyName,
                    addr: data.addr,
                    ceo: data.ceo,
                    mailOrderLicense: data.mailOrderLicense
                };

                const translations = {};

                // Process in parallel
                await Promise.all(targetLocales.map(async (lang) => {
                    try {
                        const trRes = {};
                        for (const [key, value] of Object.entries(fieldsToTranslate)) {
                            if (value) trRes[key] = await TranslationService.translate(value, lang);
                        }
                        translations[lang] = trRes;
                    } catch (err) {
                        console.warn(`Translation failed for ${lang}`, err);
                    }
                }));

                data.translations = translations;
            }

            await setDoc(doc(db, "settings", "businessInfo"), data, { merge: true });

            alert("설정이 저장되었습니다. (다국어 번역 포함)");

        } catch (e) {
            console.error("Save Error:", e);
            alert("저장 실패: " + e.message);
        } finally {
            btnSave.disabled = false;
            btnSave.innerHTML = originalBtnText; // Restore Original Icon
        }
    };
};
